import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import {
  Navigation,
  Hero,
  WhyExists,
  WhatItIs,
  WhatItIsNot,
  LearningPillars,
  ModernEcosystems,
  Collaboration,
  WhyOrganizations,
  WhoThisIsFor,
  CommunityExperiences,
  FAQ,
  FinalCTA,
  Footer,
  EmailCaptureModal
} from "./components/sections";
import AdminPage from "./components/AdminPage";

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div data-testid="flexx-home" className="flexx-wrapper">
      <Navigation onJoinClick={openModal} />
      <Hero onJoinClick={openModal} />
      <WhyExists />
      <WhatItIs />
      <WhatItIsNot />
      <LearningPillars />
      <ModernEcosystems />
      <Collaboration />
      <WhyOrganizations />
      <WhoThisIsFor />
      <CommunityExperiences />
      <FAQ />
      <FinalCTA onJoinClick={openModal} />
      <Footer />
      <EmailCaptureModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
